module.exports = __webpack_public_path__ + "static/img/job_7.27891123.png";